export const state = {
  report: null,
  reports: [],
  question: null,
  questions: [],
  user_categories: [],
};
